import { Link } from 'react-router-dom';
import { timeSlots } from '@/mocks/feed';
import SectionHeading from '@/components/base/SectionHeading';

const slotIcons: Record<string, string> = {
  午夜档: 'ri-moon-line',
  凌晨档: 'ri-moon-foggy-line',
  后半夜: 'ri-sun-foggy-line',
  通宵场: 'ri-fire-line',
  失眠特供: 'ri-heart-3-line',
};

export default function SlotSection() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="Time Slots"
        title="按上线时段找内容"
        desc="你可能只是想找睡前那一段，也可能刚通宵完想补全整晚。按时段切进去，看到的内容节奏完全不一样。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {timeSlots.map((slot, index) => (
          <Link
            key={slot.key}
            to={`/feed?slot=${encodeURIComponent(slot.key)}`}
            className="group flex flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5 transition-colors duration-300 hover:border-accent-500/45 hover:bg-background-100"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/12 text-accent-300">
                <i className={`${slotIcons[slot.key]} text-xl`} />
              </span>
              <span className="font-display text-xl tracking-wide text-foreground-500">
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-accent-300">
              {slot.key}
            </h3>
            <p className="mt-1 font-label text-xs tabular-nums text-foreground-500">{slot.range}</p>
            <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600">{slot.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 font-label text-xs text-primary-300">
              进入该时段
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}